import { render, staticRenderFns } from "./EditTheme.vue?vue&type=template&id=065831b6&scoped=true"
import script from "./EditTheme.vue?vue&type=script&lang=js"
export * from "./EditTheme.vue?vue&type=script&lang=js"
import style0 from "./EditTheme.vue?vue&type=style&index=0&id=065831b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065831b6",
  null
  
)

export default component.exports